import { render, staticRenderFns } from "./MsgModal.vue?vue&type=template&id=88a4934c"
import script from "./MsgModal.vue?vue&type=script&lang=js"
export * from "./MsgModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports